import "./index.css";

import Amplify from "aws-amplify";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import Config from "./config";
import React from "react";
import ReactDOM from "react-dom";
import { RecoilRoot } from "recoil";
import reportWebVitals from "./reportWebVitals";

console.log(
  "process.env.REACT_APP_ENVIRONMENT",
  process.env.REACT_APP_ENVIRONMENT
);

Amplify.configure(Config);

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
